import { useQueryClient } from "@tanstack/react-query";
import { Spin } from "antd";
import React, { useEffect, useState } from "react";

import auth from "@/api/auth";
import { useUserStore } from "@/store/zustand/useUserStore";

const UserInfoProvider = ({
  children
}) => {
  const user = useUserStore((state) => state.user);
  const setUser = useUserStore((state) => state.setUser);
  const [loading, setLoading] = useState(true);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!user) {
      setLoading(false);
    } else {
      auth.check(queryClient).then((response) => {
        const { data } = response.data;
        setUser(data.user);
        setLoading(false);
      });
    }
  }, []);

  if (loading) {
    return (
      <div style={{ marginTop: 50, textAlign: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  return children;
};

export default UserInfoProvider;
